import { App } from 'vue';
import VChart from 'vue-echarts';
import { use } from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import {
  LineChart,
  BarChart
} from 'echarts/charts';
import {
  GridComponent,
  TooltipComponent,
  LegendComponent,
  ToolboxComponent,
  DataZoomComponent,
  MarkLineComponent
} from 'echarts/components';

/**
 * Инициализация ECharts компонентов
 * @param app Vue инстанс
 */
export function initECharts(app: App<Element>) {
  // Регистрируем необходимые компоненты ECharts
  use([
    CanvasRenderer,
    LineChart,
    BarChart,
    GridComponent,
    TooltipComponent,
    LegendComponent,
    ToolboxComponent,
    DataZoomComponent,
    MarkLineComponent
  ]);
  
  // Регистрируем глобальный компонент
  app.component('VChart', VChart);
} 